// 쿠키에서 토큰 가져오기
export const getTokenFromCookie = () => {
  const cookies = document.cookie.split(';');
  const tokenCookie = cookies.find((cookie) => cookie.trim().startsWith('auth_token='));
  return tokenCookie ? tokenCookie.split('=')[1] : null;
};

// 쿠키에 토큰 설정
export const setTokenCookie = (token: string, domain: string) => {
  document.cookie = `auth_token=${token}; domain=${domain}; path=/; max-age=3600; secure`; // 1시간 유효
};

// 쿠키에서 토큰 삭제
export const removeTokenCookie = (domain: string) => {
  document.cookie = `auth_token=; domain=${domain}; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
};
